// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

export enum CheckNetworkTCPConnectivityFeedback {
  Succeeded,
  MeetingSessionURLsNotInitialized,
  ConnectionFailed,
  ICENegotiationFailed,
}

export default CheckNetworkTCPConnectivityFeedback;
